// src/hooks/useFinalizeSinisterStatus.ts
import { useState } from "react";
import { useToast } from "../../../shared/hooks";
import { SinisterService } from "../../../shared/services/api/sinister/SinisterService";
import { ToastContent } from "../../../shared/components";

export function useFinalizeSinisterStatus(refetch: () => void, onClose: () => void) {
	const [isLoading, setIsLoading] = useState(false);
	const toast = useToast();

	const finalize = async (id: string, data: { finalizedAt: string; finalizedNote: string; }) => {
		setIsLoading(true);
		try {
			await SinisterService.finalizeSinister(id, data);
			await refetch();

			toast.present({
				type: "success",
				position: "top-right",
				messageOrContent: <ToastContent title="Sucesso" content="Sinistro finalizado com sucesso!" />,
			});

			onClose();
		} catch (error) {
			toast.present({
				type: "error",
				messageOrContent: "Erro ao finalizar o sinistro.",
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { finalize, isLoading };
}
